import kebabCase from 'lodash/kebabCase'
import ValidationErrors from './validation-errors'

export default {
  components: { ValidationErrors },

  props: {
    displayInColumns: {
      type: Boolean,
      default: true
    },
    nameForInputField: {
      type: String,
      required: false
    },
    options: {
      // 0: display name
      // 1: value
      // 2: disabled boolean (optional)
      type: Array,
      required: true
    },
    validationErrors: {
      type: Array,
      required: false
    },
    value: {
      type: Array,
      required: true
    }
  },

  emits: ['changed'],

  data() {
    return {
      selectedIds: this.value
    }
  },

  computed: {
    showValidationError() {
      return this.validationErrors && this.validationErrors.length > 0
    }
  },

  watch: {
    value: {
      handler() {
        this.selectedIds = this.value
      },
      deep: true
    }
  },

  methods: {
    disabledForOption(option) {
      return !!option[2]
    },

    displayNameForOption(option) {
      return option[0]
    },

    idForOption(option) {
      return kebabCase(`${this.nameForInputField}-${option[1]}`)
    },

    updateSelection() {
      this.$emit('changed', this.selectedIds)
    },

    valueForOption(option) {
      return option[1]
    }
  }
}
